module.exports = __webpack_public_path__ + "img/uid-token-login.dff62f17.png";